import React, { Suspense, lazy } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { Routes, Route } from "react-router-dom";
import { Box } from "@mui/material";

import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";
import AdminLayout from "./layouts/AdminLayout";
import PatientLayout from "./layouts/PatientLayout";
import Protected from "./ProtectedRoute";
import PatientProtected from "./PatientProtectedRoutes";
import ScrollToHash from "./components/ScrollToHash";

// Lazy-loaded pages
const Home = lazy(() => import("./pages/Home"));
const Faq = lazy(() => import("./pages/Faq"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const Dashboard = lazy(() => import("./pages/lab_admin/Dashboard"));
const PatientLogin = lazy(() => import("./pages/PatientLogin"));
const Patient = lazy(() => import("./pages/lab_admin/patient/Index"));
const AddNewPatient = lazy(() => import("./pages/lab_admin/patient/addPatient"));
const UpdatePatient = lazy(() => import("./pages/lab_admin/patient/updatePatient"));
const TestGroup = lazy(() => import("./pages/lab_admin/test_group/Index"));
const Tests = lazy(() => import("./pages/lab_admin/tests/Index"));
const LabMatrix = lazy(() => import("./pages/lab_admin/lab_matrix/Index"));
const PatientDiagnose = lazy(() => import("./pages/lab_admin/patient_diagnose/Index"));
const Settings = lazy(() => import("./pages/lab_admin/settings/Index"));
const Queries = lazy(() => import("./pages/lab_admin/queries/Index"));
const Billing = lazy(() => import("./pages/lab_admin/billing/Index"));
const PateintReport = lazy(() => import("./pages/lab_admin/patient_report/Index"));
const LabProfile = lazy(() => import("./pages/lab_admin/profile/Index"));

const PatientDashboard = lazy(() => import("./pages/patient/PatientDashboard"));
const MyReports = lazy(() => import("./pages/patient/my_reports/Index"));
const MyTests = lazy(() => import("./pages/patient/my_tests/Index"));
const MyProfile = lazy(() => import("./pages/patient/profile/Index"));

const NotFound  = lazy(() => import("./pages/NotFound"));

const AppRoutes = () => {
  return (
    <>
      <ScrollToHash />
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              backgroundImage: "url(/images/banner_main.jpg)",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '100vw',
            }}
          >
            <Box>
              <CircularProgress />
            </Box>
          </Box>
        }
      >
        <Routes>
          <Route element={<Protected />}>
            <Route element={<AdminLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/patients" element={<Patient />} />
              <Route path="/patients/create" element={<AddNewPatient />} />
              <Route path="/patient/update/:id" element={<UpdatePatient />} />
              <Route path="/patient-diagnostics" element={<PatientDiagnose />} />
              <Route path="/patient-reports" element={<PateintReport />} />
              <Route path="/test-groups" element={<TestGroup />} />
              <Route path="/lab-tests" element={<Tests />} />
              <Route path="/lab-matrix" element={<LabMatrix />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/query-box" element={<Queries />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/lab-profile" element={<LabProfile />} />
            </Route>
          </Route>

          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/faq" element={<Faq />} />
          </Route>

          <Route element={<AuthLayout />}>
            <Route path="/patient-login" element={<PatientLogin />} />
            <Route path="/lab-login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>

          <Route element={<PatientProtected />}>
            <Route element={<PatientLayout />}>
              <Route path="/patient-dashboard" element={<PatientDashboard />} />
              <Route path="/patient/reports" element={<MyReports />} />
              <Route path="/patient/tests" element={<MyTests />} />
              <Route path="/patient/profile" element={<MyProfile />} />
            </Route>
          </Route>

          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRoutes;
